import { useState } from "react";
import { Drawer } from "antd";
import { useTranslation } from "react-i18next";
import FareRules from "../../FareRules/FareRules";
import FareRulesTrigger from "../components/FareRulesTrigger";

export default function FareRulesDrawerWeb() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <FareRulesTrigger onOpen={() => setOpen(true)} />
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        placement="right"
        size={"70%"}
        closable={{ placement: "end" }}
        title={t("Flights.details.fareRules.fareRules")}
      >
        <FareRules />
      </Drawer>
    </>
  );
}
